// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyCnbs_zMJ-6G6_nloMJeDiyRgv9fdbklGU",
    authDomain: "testihm-42bcf.firebaseapp.com",
    projectId: "testihm-42bcf",
    storageBucket: "testihm-42bcf.appspot.com",
    messagingSenderId: "303054105074",
    appId: "1:303054105074:web:722e74bb2096bdcb24236b",
    measurementId: "G-VMN05ZMBHL"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
